import script from "./ShareButton.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ShareButton.vue?vue&type=script&lang=js"
export * from "./ShareButton.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ShareButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-components/base-story-card/ShareButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1db97f0e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1db97f0e', __exports__)) {
    api.reload('1db97f0e', __exports__)
  }
  
}


export default __exports__